import { Box } from '@chakra-ui/react';
import { useParentAppLayout } from '@src/components/sco/AppLayout/AppLayoutContext';
import { PlaybookDetail } from '@src/components/sco/Education/PlaybookDetail';
import { useUniversalEffect } from '@src/hooks/useUniversalEffect';
import { EducationPage } from '@src/templates/EducationPage';
import { useParams } from 'next/navigation';
import React from 'react';
export { getServerSideProps } from '@src/lib/server-side-rendering';
export default EducationPage(function Page(props) {
  const layout = useParentAppLayout();
  const routeParams = useParams();
  useUniversalEffect(() => {
    layout.updatePanel('edu-aside', {
      isPanelOpen: false
    });
  }, []);
  return <Box padding={['1em', '1em', '2em']}>
      <PlaybookDetail playbookSlug={`${routeParams?.playbookSlug}`} />
    </Box>;
});